import { Component, OnDestroy, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { SpinnerService } from './spinner.service';

@Component({
  selector: 'app-spinner',
  templateUrl: './spinner.component.html',
  styleUrls: ['./spinner.component.scss']
})
export class SpinnerComponent implements OnInit, OnDestroy {

  showSpinner: Observable<boolean>;

  constructor(private spinnerService: SpinnerService) {
    this.showSpinner = this.spinnerService.isLoading;
  }

  ngOnInit(): void {
  }

  ngOnDestroy(): void {
  }

}
